module.exports = __webpack_public_path__ + "e369292a0d6bd2df668376ee3ea1834d.svg";